module.exports = __webpack_public_path__ + "static/img/plate-delimiter.b73ba10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/plate-delimiter.png
// module id = 515
// module chunks = 1